import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=2cea8524&scoped=true&"
import script from "./teams.vue?vue&type=script&lang=js&"
export * from "./teams.vue?vue&type=script&lang=js&"
import style0 from "./teams.vue?vue&type=style&index=0&id=2cea8524&lang=scss&scoped=true&"
import style1 from "./teams.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea8524",
  null
  
)

export default component.exports